import { object } from 'common/helpers'


export const initialState = {
  isFetching: false,
  info: {
    labels: [],
    notes: [],
    tags: [],
    volumes: [],
    isVisible: true,
    isGenderVisible: false,
    isSubscribedToStockNotification: false,
  },
  activeVolumeIndex: 0,
}

export const setFetching = (state, payload) => (
  object.set(state, 'isFetching', payload)
)

export const set = (state, payload) => {
  const {
    isLimitedEdition = false,
    isSubscribedToStockNotification = false,
    limitedEditionVolumeCustomText = null,
    ...rest
  } = payload

  return {
    ...state,
    isFetching: false,
    info: {
      ...state.info,
      ...rest,
      isLimitedEdition,
      limitedEditionVolumeCustomText,
      isSubscribedToStockNotification,
    },
  }
}

export const setActiveVolumeIndex = (state, payload /* index */) => (
  object.set(state, 'activeVolumeIndex', payload)
)

export const setIsSubscribedToStockNotification = (state, payload) => (
  object.setIn(state, [ 'info', 'isSubscribedToStockNotification' ], payload)
)

export const reset = () => initialState
